var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmokingCessation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 150,
    viewBox: "0 0 251 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 126C69.4903 126 48 104.51 48 78C48 51.4903 69.4903 30 96 30C122.51 30 144 51.4903 144 78C144 104.51 122.51 126 96 126Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123 150C96.4903 150 75 128.51 75 102C75 75.4903 96.4903 54 123 54C149.51 54 171 75.4903 171 102C171 128.51 149.51 150 123 150Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151 96C124.49 96 103 74.5097 103 48C103 21.4903 124.49 0 151 0C177.51 0 199 21.4903 199 48C199 74.5097 177.51 96 151 96Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155 135C126.281 135 103 111.719 103 83C103 54.2812 126.281 31 155 31C183.719 31 207 54.2812 207 83C207 111.719 183.719 135 155 135Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109 90C84.6995 90 65 70.3005 65 46C65 21.6995 84.6995 2 109 2C133.301 2 153 21.6995 153 46C153 70.3005 133.301 90 109 90Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 251 57)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 48 135)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 62)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 48 5)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 205 4)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 227 138)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 21,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#D7512D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97 72C97 70.8954 97.8954 70 99 70H110C110.552 70 111 70.4477 111 71V81C111 81.5523 110.552 82 110 82H99C97.8954 82 97 81.1046 97 80V72Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 81V71C114 70.4477 114.448 70 115 70H121.586C121.851 70 122.105 70.1054 122.293 70.2929L132.293 80.2929C132.923 80.9229 132.477 82 131.586 82H115C114.448 82 114 81.5523 114 81Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157 72V80C157 81.1046 156.105 82 155 82H142.828C142.298 82 141.789 81.7893 141.414 81.4142L131.707 71.7071C131.077 71.0771 131.523 70 132.414 70H155C156.105 70 157 70.8954 157 72Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151 49L150.298 50.8713C149.489 53.0281 149.836 55.4485 151.218 57.2913V57.2913C152.354 58.8049 152.801 60.7255 152.453 62.5851L152 65",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142 48L141.298 49.8713C140.489 52.0281 140.836 54.4485 142.218 56.2913V56.2913C143.354 57.8049 143.801 59.7255 143.453 61.5851L143 64",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48L146 94",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5L30.5 24.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 27L236.5 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228 99.5L248 103",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 99.5L3.5 107.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokingCessation);
export default __webpack_public_path__ + "static/media/smoking-cessation.41e980275550739b9ca40b49c28de1d4.svg";
export { ForwardRef as ReactComponent };